import type { CompanyInsights } from "@/modules/community/api/types/companyInsights"
import type { NextRequest } from "@/modules/fetch/types"

import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { toCamelCaseKeys } from "@/modules/format/object/toCamelCaseKeys"
import { toSnakeCaseKeys } from "@/modules/format/object/toSnakeCaseKeys"

export const COMPANY_INSIGHTS_QUERY_KEY = "community::companyInsights"

const COMPANY_INSIGHTS_ENDPOINT = "/jobteaser.community.v1alpha1/CommunityService/GetCompanyRelatedExperiencesInfos"

type CompanyInsightsRequest = {
  companyId: string
  req?: NextRequest
  schoolId?: string
}

export const getCompanyInsights = async ({
  companyId,
  req,
  schoolId,
}: CompanyInsightsRequest): Promise<CompanyInsights> =>
  fetcher(COMPANY_INSIGHTS_ENDPOINT, {
    nextRequest: req,
    requestInit: {
      body: JSON.stringify(toSnakeCaseKeys({ companyId, schoolId })),
      method: "POST",
    },
    serviceDomain: "APIGW_IN_KRAKEND_API",
  })
    .then(getResultFromResponse<CompanyInsights>({ transformResult: toCamelCaseKeys<CompanyInsights> }))
    .catch(handleFetchError(COMPANY_INSIGHTS_ENDPOINT, { companyId, schoolId }))
